import type { NavigateOptions } from '@tanstack/react-router';

import { TLConversationType } from '@/api/gen/tessera-backend-api.schemas';

export type ConversationLocation = {
  conversationId: string;
  conversationType?: TLConversationType | null;
  workflowId?: string | null;
  templateId?: string | null;
};

export function resolveConversationRoute(
  { conversationId, conversationType, workflowId, templateId }: ConversationLocation,
  tenantId: string,
): NavigateOptions {
  switch (conversationType) {
    case TLConversationType.WORKFLOW_CHAT:
      if (templateId) {
        return {
          to: '/t/$tenantId/loom/templates/$templateId',
          params: { tenantId, templateId },
          search: { chatConversationId: conversationId },
        };
      }
      if (workflowId) {
        return {
          to: '/t/$tenantId/loom/$workflowId',
          params: { tenantId, workflowId },
          search: { chatConversationId: conversationId },
        };
      }
      return {
        to: '/t/$tenantId/loom/new',
        params: { tenantId },
        search: { chatConversationId: conversationId },
      };
    case TLConversationType.KB_CHAT:
      return {
        to: '/t/$tenantId/knowledge-base',
        params: { tenantId },
        search: { chatConversationId: conversationId },
      };
    case TLConversationType.DATA_HARMONIZATION_CHAT:
      return {
        to: '/t/$tenantId/data-harmonization',
        params: { tenantId },
        search: { chatConversationId: conversationId },
      };
    case TLConversationType.DATA_FOUNDRY_CHAT:
      return {
        to: '/t/$tenantId/data-foundry',
        params: { tenantId },
        search: { chatConversationId: conversationId },
      };
    case TLConversationType.RELEASE_CHAT:
      // Release chats live only in the Releases page's panel; there is no standalone view.
      return {
        to: '/t/$tenantId/platform/releases',
        params: { tenantId },
      };
    default:
      // NEXUS_CHAT is deliberate here: its shell is project-scoped and the conversation carries
      // no project id; VR/editor chats are view/system-bound the same way.
      return {
        to: '/t/$tenantId/conversation/$conversationId',
        params: { tenantId, conversationId },
      };
  }
}
